/** Apache-2.0 replacement for `@/ee/whitelabeling` (Omnyqra/sim#14). See `SPEC.md`. */
import type { BrandConfig, OrganizationWhitelabelSettings } from '@/lib/branding/types'

export type { BrandConfig, OrganizationWhitelabelSettings } from '@/lib/branding/types'
export { getBrandConfig, useBrandConfig } from '@/ee/whitelabeling/brand-config'
export { generateBrandedMetadata } from '@/ee/whitelabeling/metadata'
export { generateThemeCSS } from '@/ee/whitelabeling/theme'

/** Organization white-labeling is off, so the instance branding stays as it is (WL-005). */
export function mergeOrgBrandConfig(
  _orgSettings: OrganizationWhitelabelSettings | null,
  base: BrandConfig
): BrandConfig {
  return base
}
